import React, { useState, useRef, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'

// react router
import { Link } from 'react-router-dom'

// icons : feather
import FeatherIcon from 'feather-icons-react';

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react toastify
import { toast } from 'react-toastify';

// includes
import EmailsFormContentView from './Includes/BlogsFormContentView'

// APIs
import { getBlogDetails, cancelGetBlogDetailsApi, editBlog } from 'utlis/Apis/Blogs_API'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
    BLOG_UPDATED_SUCCESSFULLY,
    ERROR_WHILE_UPDATING_BLOG,
    ERROR_WHILE_GETTING_BLOG_DETAILS,
} from 'utlis/AppMessages/AppMessages'
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function EditEmail(props) {
    // props
    const { authState } = props

    // refs
    const submitButtonRef = useRef(null)

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    //const [blogId, setBlogId] = useState("")

    const [editButtonDisable, setEditButtonDisable] = useState(false)
    const [editButtonLoading, setEditButtonLoading] = useState(false)

    // const [emailEvents, setEmailEvents] = useState([])

    const [blogId, setBlogId] = useState([])
    const [blog, setBlog] = useState({})

    /*
    // on page load
    useEffect(() => {
        const blogIdFromUrl = props.match.params;
        // setting user id from the url
        if (blogIdFromUrl) {
            setBlogId(blogIdFromUrl.id)
        }

        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        // getting event id
        getEmailEvents(props.currentUser.userToken, blogId).then(res => {
            const emailEvents = res.data

            // if request is success
            if (emailEvents.success) {
                setEmailEvents(emailEvents.data.data)
            }

            // if request is not succeed
            if (emailEvents.error) {
                console.log('Error occured while loading email events!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getEmailEvents `, err.message)

            // dismissing all the previous toasts first
            toast.dismiss();

            // showing the error message
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })

        return () => {
            // canceling admin users api when user leaves the component
            cancelGetEmailEventsApi()
        }
    }, [authState])
    */
    // geting form values from the url
    useEffect(() => {
        const locState = props.location.state ?? props.location.state

        // if state with the email exists in the location
        if (locState) {
            const blogData = locState.blogDetails
            setBlogId(blogData?.blog_id)
            setBlog(blogData || {})
        }
    }, [props])

    // geting form values from the database if not found in the url
    useEffect(() => {
        const locState = props.location.state ?? props.location.state
        // if state with the user exists in the location
        if (!locState) {
            // enabling the global loading
            props.setGlobalLoading(true)
            // loading the user from the database
            const blogId = props.match.params.id ?? ""

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }

            // getting single email details
            getBlogDetails(headers, blogId).then(res => {
                const blogData = res.data

                // disabling the global loading
                props.setGlobalLoading(false)

                // if request is success
                if (blogData.success) {
                    setBlogId(blogData?.data?.blog_id)
                    setBlog(blogData.data || {})
                    // setting the form fields
                    // formik.setFieldValue("blogTitle", blogData?.data?.title ?? "")
                    // formik.setFieldValue("blogAuthor", blogData?.data?.author_name ?? "")
                    // formik.setFieldValue("blogDescription", blogData?.data?.description ?? "")
                    // formik.setFieldValue("blogMetaTitle", blogData?.data?.meta_title ?? "")
                    // formik.setFieldValue("blogMetaDescription", blogData?.data?.meta_description ?? "")
                    // formik.setFieldValue("blogTags", blogData?.data?.tags ?? "")
                }
                // if request is not succeed
                if (blogData.error) {
                    console.log(ERROR_WHILE_GETTING_BLOG_DETAILS, res)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_GETTING_BLOG_DETAILS, {
                        autoClose: 3000,
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getBlogDetails `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // disabling the global loading
                props.setGlobalLoading(false)

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            })

            return () => {
                // disabling the global loading
                props.setGlobalLoading(false)

                // canceling admin users api when user leaves the component
                cancelGetBlogDetailsApi()
            }
        }

    }, [props])

    // html editor
    const getHTML_editorResult = (data) => {
        // setting email content
        formik.setFieldValue("blogDescription", data)
    }

    // initial edit email form values
    const initialEditFormValues = {
        blogTitle: blog.title || "",
        blogAuthor: blog.author_name || "",
        blogDescription: blog.description || "",
        blogMetaTitle: blog.meta_title || "",
        blogMetaDescription: blog.meta_description || "",
        blogTags: blog.tags || "",
    }

    // handle edit email form validations
    const editFormValidationSchema = Yup.object({
        blogTitle: Yup.string().required('This field is required'),
        blogAuthor: Yup.string(),
        blogDescription: Yup.string(),
        blogMetaTitle: Yup.string(),
        blogMetaDescription: Yup.string(),
        blogTags: Yup.string(),
    })

    // handle edit email form submmision
    const onBlogFormSubmit = values => {
        if (values) {
            // enabling global loading
            setGlobalLoading(true)

            // disabling the button and enabling loading
            setEditButtonDisable(true)
            setEditButtonLoading(true)

            // saving the email in the database
            const dataToBeSaved = {
                blog_id: blogId,
                title: values.blogTitle,
                author_name: values.blogAuthor,
                tags: values.blogTags,
                meta_description: values.blogMetaDescription,
                meta_title: values.blogMetaTitle,
                description: values.blogDescription,
            }

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }

            // updating the user details from the database
            editBlog(headers, dataToBeSaved).then(res => {
                // disabling global loading
                setGlobalLoading(false)

                // enabling the button and disabling loading
                setEditButtonDisable(false)
                setEditButtonLoading(false)

                const emailUpdated = res.data

                // if successfully created
                if (emailUpdated.success) {

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing success message
                    toast.success(BLOG_UPDATED_SUCCESSFULLY, {
                        autoClose: 3000
                    })
                }

                // if some error
                if (emailUpdated.error) {
                    console.log(ERROR_WHILE_UPDATING_BLOG, res)
                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.error(ERROR_WHILE_UPDATING_BLOG, {
                        autoClose: 3000
                    })
                }
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} editBlog `, err.message)

                // dismissing all the previous toasts first
                toast.dismiss();

                // showing the error message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // disabling global loading
                        setGlobalLoading(false)

                        // enabling the button and disabling loading
                        setEditButtonDisable(false)
                        setEditButtonLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialEditFormValues,
        validationSchema: editFormValidationSchema,
        onSubmit: onBlogFormSubmit,
        enableReinitialize: true
    })

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitButtonRef.current.click()
    }

    return (
        <section id="app-emails__edit-details" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-emails__edit-details">
                    {/* BACK BUTTON WRAPPER */}
                    <div className="back-button-wrapper mb-2">
                        <Link to={storeUrl + "catalog/blogs"} className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15">
                            <FeatherIcon
                                icon="arrow-left"
                                size="14"
                                className="icon me-1" />
                            <span>Back to Blogs</span>
                        </Link>
                    </div>

                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Edit Blog</p>
                        <p className="app-desc">
                        </p>
                    </div>
                    {/* 1053753 */}

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            <EmailsFormContentView
                                formik={formik}
                                emailEvents={[]} //emailEvents
                                getHTML_editorResult={getHTML_editorResult}
                            />

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${props.sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/settings/emails"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(editButtonDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={editButtonDisable || Object.keys(formik.errors).length}
                                        onClick={handleFormSubmission}>
                                        {
                                            editButtonLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Save Changes</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        <button type="submit" ref={submitButtonRef} className="d-none">submit</button>
                    </form>

                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(EditEmail)